import Svg, { Path } from 'react-native-svg'

export const AddUserIcon = ({ height = 24, width = 24, color = '#000' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M8 11c1.93 0 3.5-1.57 3.5-3.5S9.93 4 8 4 4.5 5.57 4.5 7.5 6.07 11 8 11Zm0 1c-3.31 0-6 2.69-6 6 0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2 0-3.31-2.69-6-6-6Zm13-2h-2V8c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1Z"
      />
    </Svg>
  )
}
